/**
 * Component Registry for 110 Royy
 * 
 * Inherits from @vibesites-repli-sandbox-avenue/theme-avenue and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-repli-sandbox-avenue/theme-avenue/registry';
import { PropertyOverview } from './components/PropertyOverview';
import { PageBlurb } from './components/PageBlurb';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PropertyOverview,
  PageBlurb,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
